import { atom } from "jotai";

export const notificationsPanelOpenAtom = atom(false);
